import {
  ActionDetail,
  ActionExecLog,
  AutoDraftMeta,
  MediaAction,
  SchedulePlanItem
} from '@/common/model/media/mediaAction'

export const MediaActionApiPath = {
  LIST_ACTIONS: '/api/sites/{site_id}/media-action', // GET List Actions
  GET_ACTION_DETAIL: '/api/sites/{site_id}/media-action/{action_id}/detail', // GET Action Detail
  GET_SUMMARY: '/api/sites/{site_id}/media-action/summary', // GET Summary
  GET_EXEC_LOG_BULK: '/api/sites/{site_id}/media-action/exec-log-bulk', // GET Exec Log Bulk
  UPDATE_ACTION: '/api/sites/{site_id}/media-action/{action_id}', // PUT Update Action
  AUTO_SCHEDULE: '/api/sites/{site_id}/media-action/auto-schedule', // POST Auto Schedule
  REQUEST_AUTO_ARTICLE_CREATION:
    '/api/sites/{site_id}/media-action/{action_id}/request-auto-article-creation', // POST Request Auto Article Creation
  DECOMPOSE_STRATEGIC: '/api/sites/{site_id}/media-action/{action_id}/decompose-strategic' // POST Decompose Strategic
}

export type MediaActionApiPath = (typeof MediaActionApiPath)[keyof typeof MediaActionApiPath]

// -----------------------------------------------
// Vars
// -----------------------------------------------

export interface ListActionsVars {
  site_id: number
  status?: string | null
  action_type?: string | null
  source_type?: string | null
  source_analytics_id?: number | null
  q?: string | null
  sort?: string
  unscheduled_only?: boolean
  page?: number
  per_page?: number
}

export interface ActionIdVars {
  site_id: number
  action_id: number
}

export interface ExecLogBulkVars {
  site_id: number
  ids: string // カンマ区切りの action_id
}

export interface UpdateActionVars {
  site_id: number
  action_id: number
  status?: string
  title?: string
  description?: string
  priority?: string
  rejection_note?: string
  scheduled_date?: string
  start_planned_date?: string
  execution_order?: number
}

export interface AutoScheduleVars {
  site_id: number
  horizon_days?: number
  max_per_week?: number
  start_date?: string
  weekend_off?: boolean
  focus_mode?: string
  use_ai?: boolean
  apply?: boolean
  action_ids?: number[] | null
}

// -----------------------------------------------
// Responses
// -----------------------------------------------

export interface ListActionsResponse {
  total: number
  items: MediaAction[]
}

export type ActionDetailResponse = ActionDetail

export interface ActionSummaryResponse {
  counts: Record<string, number>
  top: MediaAction[]
}

export interface ExecLogBulkResponse {
  items: ActionExecLog[]
}

export type UpdateActionResponse = MediaAction

export interface AutoScheduleResponse {
  plan: SchedulePlanItem[]
  applied: boolean
  ai_used: boolean
}

// 戦略アクションのAI分解の結果。meta に生成された子アクション（decomposed）・要約・エラーが入る
export interface DecomposeStrategicResponse {
  ok: boolean
  status: string
  meta: AutoDraftMeta
}
